import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Logo from './Logo';
import SafeIcon from '../common/SafeIcon';
import { FiHeart } from 'react-icons/fi';

const Header = ({ language, setLanguage }) => {
  const scrollToSponsor = () => {
    const sponsorSection = document.getElementById('sponsor-section');
    if (sponsorSection) {
      // First expand the section if it's not already expanded
      const expandButton = sponsorSection.querySelector('button');
      const isExpanded = sponsorSection.getAttribute('data-expanded') === 'true';
      
      if (!isExpanded && expandButton) {
        expandButton.click();
        
        // Wait for expansion animation to complete before scrolling
        setTimeout(() => {
          sponsorSection.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start'
          });
        }, 350); // Slightly longer than the animation duration (300ms)
      } else {
        // If already expanded, just scroll
        sponsorSection.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start'
        });
      }
    }
  };

  return (
    <motion.div 
      className="mb-8 relative"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="rounded-xl bg-gradient-to-r from-love-100 to-secondary-100 dark:from-love-900/30 dark:to-secondary-900/30 p-4 shadow-sm">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Link to="/" aria-label={language === 'zh' ? '返回首頁' : 'Return to home'}>
              <Logo />
            </Link>
            <Link to="/" className="ml-3 text-xl md:text-2xl font-bold bg-gradient-to-r from-love-500 to-secondary-500 bg-clip-text text-transparent">
              {language === 'zh' ? '寵物紀念日' : 'Pet Days'}
            </Link>
          </div>
          
          <div className="flex items-center space-x-2">
            <motion.button
              onClick={scrollToSponsor}
              className="flex items-center px-2 sm:px-3 py-1 text-xs rounded-full bg-love-100 hover:bg-love-200 text-love-600 dark:bg-love-900/30 dark:hover:bg-love-800/50 dark:text-love-400 transition-all duration-300 shadow-sm"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              aria-label={language === 'zh' ? '支持我們' : 'Support Us'}
            >
              <SafeIcon 
                icon={FiHeart} 
                className="mr-1 text-love-500 animate-heartbeat" 
              />
              {language === 'zh' ? '支持' : 'Support'}
            </motion.button>
            
            <div className="inline-flex rounded-full bg-white/50 dark:bg-gray-800/50 p-1 shadow-inner">
              <button
                onClick={() => setLanguage('zh')}
                className={`px-2 sm:px-3 py-1 text-xs rounded-full transition-all ${
                  language === 'zh'
                    ? 'bg-white dark:bg-gray-700 text-love-500 shadow-sm font-medium'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
                aria-pressed={language === 'zh'}
              >
                中
              </button>
              <button
                onClick={() => setLanguage('en')}
                className={`px-2 sm:px-3 py-1 text-xs rounded-full transition-all ${
                  language === 'en'
                    ? 'bg-white dark:bg-gray-700 text-love-500 shadow-sm font-medium'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
                aria-pressed={language === 'en'}
              >
                EN
              </button>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Header;